import { Box, Button, ClickAwayListener, Paper, Popper, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCallback, useState, useRef } from "react";
import { makeStyles } from "tss-react/mui";


const useStyles = makeStyles()(
  (theme) => ({
    root: {
      position: "relative",
      borderRadius: theme.spacing(1),
      paddingRight: theme.spacing(0.5),
      paddingLeft: theme.spacing(1.5),
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      background: theme.palette.background.grey,
      width: "100%",
      height: "auto"
    },
    titleContainer: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(0.5)
    },
    titleText: {
      lineHeight: "100%"
    },
    textValue: {
      lineHeight: "100%"
    },
    button: {
      borderRadius: theme.spacing(1)
    },
    popper: {
      zIndex: 1000
    },
    paper: {
      borderRadius: theme.spacing(1)
    }
  })
);


export default function PlanningPopper() {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const rootEl = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [width, setWidth] = useState(0);

  const onOpen = useCallback((ev) => {
    ev.stopPropagation();
    ev.preventDefault();
    setOpen(v => !v);
    if (!!rootEl.current) {
      setWidth(rootEl.current.clientWidth);
      setAnchorEl(rootEl.current);
    }
  }, []);

  return (
    <>
      <Box className={classes.root} ref={rootEl}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" >
          <Stack direction="column" className={classes.titleContainer}>
            <Typography variant="caption" className={classes.titleText} color="textSecondary">
              Planlagt ankomst
            </Typography>
            <Typography variant="body1" className={classes.titleValue} color="textPrimary">
              Snarest
            </Typography>
          </Stack>
          <Button color="info" onClick={onOpen}>Endre</Button>
        </Stack>
      </Box>

      <Popper
        className={classes.popper}
        open={open}
        anchorEl={anchorEl}
        placement="bottom"
      >
        <ClickAwayListener onClickAway={onOpen}>
          <Paper elevation={3} sx={{ width }} className={classes.paper}>
            <Typography sx={{ p: 2 }}>
              Lorum ipsum blah blah blah
            </Typography>
          </Paper>
        </ClickAwayListener>

      </Popper>
    </>
  );
}